/* Gallery wall set — add-all-to-cart. The ONE set add-to-cart path (HD-P0-16:
 * this replaced assets/set-config.js, which duplicated it for the set product template).
 *
 * Delegated handler for any [data-gw-add] button (works for both server-rendered
 * sections and the JS-hydrated /pages/gallery-wall preview). Reads:
 *   data-gw-lines       — preferred: JSON array of per-piece lines, as emitted by
 *                         snippets/v2-set-line: [{ id, properties, frame?, frames?, print? }].
 *                         A Product System v2 piece's line is the ARTIST product's variant
 *                         plus its signed line properties (Artwork, _artwork_id, _sku,
 *                         _quote, …); a legacy piece's is its own variant with no properties.
 *   data-gw-variants    — legacy: comma-separated Shopify variant ids (used when there is no
 *                         data-gw-lines). Kept for older markup / cached pages.
 *   data-gw-fallback    — a /cart permalink to fall back to if AJAX fails (legacy ids only:
 *                         a permalink cannot carry line properties, so v2 lines never use it)
 *   data-gw-properties  — optional JSON object of line-item properties applied to
 *                         every piece (e.g. {"_set_id":"…","_set_name":"…"})
 *   data-gw-frame-group — optional id of a radio group (sections/set-frame-selector);
 *                         its checked value picks each v2 piece's matching framed line
 *                         (or its print line for a "Print"/"Unframed" choice) and is added
 *                         to a legacy piece as `Frame`
 *   [data-gw-add-text]  — optional child whose text shows the Adding…/Added state
 *
 * Adds all pieces in one POST /cart/add.js, then opens the cart drawer
 * (ArthausCart.openWithItem) — matching the rest of the theme's add-to-cart UX.
 */
(function () {
  'use strict';
  if (window.__arthausGallerySetCart) return;   // tolerate the script being included twice
  window.__arthausGallerySetCart = true;

  function parseJSON(raw, fallback) {
    if (!raw) return fallback;
    try { return JSON.parse(raw) || fallback; } catch (e) { return fallback; }
  }

  function sharedProperties(btn) {
    var props = parseJSON(btn.getAttribute('data-gw-properties'), {});
    return (props && typeof props === 'object') ? props : {};
  }

  function frameChoice(btn) {
    var groupId = btn.getAttribute('data-gw-frame-group');
    var group = groupId && document.getElementById(groupId);
    var checked = group && group.querySelector('input[type="radio"]:checked');
    return checked && checked.value ? checked.value : '';
  }

  // "Black Walnut" → the `walnut` line, "Matte Black" → `black`: the finish is the LAST
  // matching word of the choice, so a colour adjective never wins over the wood.
  function matchFrame(frames, choice) {
    var c = choice.toLowerCase(), best = null, bestAt = -1;
    Object.keys(frames || {}).forEach(function (key) {
      var at = c.lastIndexOf(key);
      if (at > bestAt) { best = frames[key]; bestAt = at; }
    });
    return best;
  }

  function copy(o) { var r = {}; Object.keys(o || {}).forEach(function (k) { r[k] = o[k]; }); return r; }

  // One cart item for a line, honouring the set-wide frame choice.
  function itemFor(line, shared, choice) {
    var props = copy(line.properties);
    Object.keys(shared).forEach(function (k) { props[k] = shared[k]; });
    var id = line.id;
    var isV2 = !!(line.properties && line.properties._quote);
    if (isV2) {
      var alt = null;
      if (choice && /print|unframed|no frame/i.test(choice)) alt = line.print || null;
      else if (choice) alt = matchFrame(line.frames, choice);
      if (alt && alt.id && alt.q) {
        id = alt.id;
        props._sku = alt.s;
        props._quote = alt.q;
      } else {
        alt = null;
      }
      // The variant decides what ships; `Frame` states it, never a finish it is not.
      var frame = alt ? (alt.frame || '') : (line.frame || '');
      if (frame) props.Frame = frame; else delete props.Frame;
    } else if (choice) {
      props.Frame = choice;
    }
    var item = { id: Number(id), quantity: 1 };
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  function itemsFor(btn) {
    var shared = sharedProperties(btn);
    var choice = frameChoice(btn);
    var lines = parseJSON(btn.getAttribute('data-gw-lines'), null);
    if (Array.isArray(lines) && lines.length) {
      // Every piece must be buyable: a set missing a piece (a v2 shell without offers)
      // would charge for less than the wall shown, so it is not added at all.
      for (var i = 0; i < lines.length; i++) if (!lines[i] || !lines[i].id) return { items: [], lines: true };
      return { items: lines.map(function (l) { return itemFor(l, shared, choice); }), lines: true };
    }
    var ids = (btn.getAttribute('data-gw-variants') || '')
      .split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
    return { items: ids.map(function (id) { return itemFor({ id: id }, shared, choice); }), lines: false };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gw-add]');
    if (!btn) return;
    e.preventDefault();

    var label = btn.querySelector('[data-gw-add-text]') || btn;
    var orig = label.getAttribute('data-gw-label') || label.textContent;
    label.setAttribute('data-gw-label', orig);
    if (btn.getAttribute('aria-busy') === 'true') return;

    var plan = itemsFor(btn);
    var fallback = btn.getAttribute('data-gw-fallback') || '/cart';
    function fail(err) {
      if (window.console && err) console.warn('[gallery-set-cart]', err);
      if (!plan.lines) { window.location.href = fallback; return; } // /cart permalink still adds legacy ids
      label.textContent = 'Error — try again';
      setTimeout(function () { label.textContent = orig; btn.removeAttribute('aria-busy'); }, 2000);
    }
    if (!plan.items.length) {
      if (plan.lines) { btn.setAttribute('aria-busy', 'true'); fail(new Error('set has a piece that cannot be added')); }
      else window.location.href = fallback;
      return;
    }

    btn.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: plan.items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        label.textContent = 'Added ✓';
        if (window.ArthausCart && typeof window.ArthausCart.openWithItem === 'function') {
          window.ArthausCart.openWithItem();
        } else {
          window.location.href = '/cart';
        }
        setTimeout(function () { label.textContent = orig; btn.removeAttribute('aria-busy'); }, 1800);
      })
      .catch(fail);
  });

  window.ArthausGallerySetCart = { itemsFor: itemsFor };
})();
